/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The NewDebtorRegistrationPayload model module.
 * @module model/NewDebtorRegistrationPayload
 * @version v1
 */
export class NewDebtorRegistrationPayload {
  /**
   * Constructs a new <code>NewDebtorRegistrationPayload</code>.
   * @alias module:model/NewDebtorRegistrationPayload
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>NewDebtorRegistrationPayload</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NewDebtorRegistrationPayload} obj Optional instance to populate.
   * @return {module:model/NewDebtorRegistrationPayload} The populated <code>NewDebtorRegistrationPayload</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new NewDebtorRegistrationPayload();
      if (data.hasOwnProperty('supplier_id'))
        obj.supplier_id = ApiClient.convertToType(data['supplier_id'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} supplier_id
 */
NewDebtorRegistrationPayload.prototype.supplier_id = undefined;

